$( document ).ready(function() {
  if($('.testimonial-slider').length > 0){
    $('.testimonial-slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
        },
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true
            }
        }
      ]
    });
  }
 if($('.section-made-with-love').length > 0){
   var counterStart = false;
   $(window).scroll(function() {
    var position = $('.section-made-with-love').offset().top;
    var windowHeight = $(window).height();
    var scrollPosition = $(this).scrollTop();
    if (scrollPosition > position - windowHeight && !counterStart) {
        counterStart = true;
      $('.counter').each(function() {
            $(this).prop('Counter', 0).animate({
              Counter: $(this).text().replace(/,/g, '')
            }, {
              duration: 9000,
              easing: 'swing',
              step: function(now) {
                $(this).text(Math.ceil(now).toLocaleString());
              }
            });
          });
       }  
    });
  }
   // custom navigation hover (Header)
  $('.header__inline-menu details').hover(function(){
      $(this).find('summary').trigger('click');
    }, function() {
     var opencheck = $(this).attr('open');
      if (typeof opencheck !== 'undefined' && opencheck !== false) {
        $(this).find('summary').trigger('click');
      }  
  });
  
  $('.show-moreinfo').click(function(){
    $(this).toggleClass('hide');
    $(this).prev().toggleClass('moreinfo-active').toggle();
  });
  $('.moreinfo-show').click(function(){
    $(this).toggleClass('hide');
    $(this).parents('.icon-with-text-section_block').find('.moreinfo-container').toggleClass('moreinfo-active').toggle();
  });
  
  if($('.section-faq').length > 0){
     $(".accordion").on("click", ".top_content", function() {
      // $(".accordion").addClass("active");
       // $('.accordion:first').show();
       if($(this).hasClass('active')){
         $(this).removeClass("active").next().slideUp();
       }else{
         $('.top_content.active').removeClass("active");
         $(".bottom_content").not($(this).next()).slideUp(300);
         $(this).addClass("active").next().slideDown();
       }
     });
     $(".faq-left-content .tab_list>.tabs").on("click",function(e) {
       e.preventDefault();
       $(".faq-left-content .tab_list>.tabs").removeClass("current");
       $(this).addClass("current");
       $(".accordion-item").hide();
       var tab_id = $(this).attr('id');
       $("#data-" +tab_id).show();
       $('.accordion-item').removeClass('current');
       $("#data-" +tab_id).addClass('current');
        $('html,body').animate({
            scrollTop: $("#data-" +tab_id).offset().top - $('header').outerHeight() - 100
        }, 1000);
     }); 
   }
   
  if($('.section-blog-slider').length > 0){
    $('.blogs-slider').slick({
        infinite: true,
        dots:true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
        },
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true
            }
        }
      ]
    });
  }
  if($('.section-main-blog').length > 0){
    $(function () {
  		$(".blog-article-section").slice(0, 6).show();
  		$("body").on('click touchstart', '.load-more', function (e) {
  			e.preventDefault();
  			$(".blog-article-section:hidden").slice(0, 6).slideDown();
  			if ($(".blog-article-section:hidden").length == 0) {
  				$(".load-more").css('visibility', 'hidden');
  			}
  			$('html,body').animate({
  				scrollTop: $(this).offset().top
  			}, 1000);
  		});
  	});
  }
  
    if($('.section-our-mission-track-impact').length > 0){ 
      var counterStart = false; 
      $(window).scroll(function() {
        var position = $('.section-our-mission-track-impact').offset().top;
        var windowHeight = $(window).height();
        var scrollPosition = $(this).scrollTop();
        if (scrollPosition > position - windowHeight && !counterStart) {
          counterStart = true;
          $('.counter').each(function() {
            $(this).prop('Counter', 0).animate({
              Counter: $(this).text().replace(/,/g, '')
            }, {
              duration: 9000,
              easing: 'swing',
              step: function(now) {
                $(this).text(Math.ceil(now).toLocaleString());
              }
            });
          });
          if($('.our-mission-track-impact__count').length > 0){ 
            var total_digit = $('.our-mission-track-impact__count').attr('data-count').toString().length;
            var new_total_digit = total_digit;
              var countobj=$('.count').get(0);
              for (var i=1;i<total_digit;i++){
                $(".our-mission-track-impact__count").append(' <span class="count"> 0 </span>');
              }
              $('.count').each(function () {
                  $(this).prop('Counter',0).animate({
                      Counter: $('.our-mission-track-impact__count').attr('data-count')
                  }, {
                      duration: 5000,
                      easing: 'swing',
                      step: function (now) {
                      var num = Math.ceil(now).toString()
                      num = num.padStart(total_digit, '0')
                        for (var i=1; i <= total_digit; i++ ){
                            $('.our-mission-track-impact__count span:nth-child('+i+')').text(num.charAt(i-1))
                        }
                      }
                  });
              });
          }
        }
      });
    }

});